import script from "./Operations.vue?vue&type=script&setup=true&lang=js"
export * from "./Operations.vue?vue&type=script&setup=true&lang=js"

import "./Operations.vue?vue&type=style&index=0&id=c03f4182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c03f4182"]])

export default __exports__